import TakeawayWaitingSummary from '../../components/TakeawayWaitingSummary'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as basketActions from '../../actions/components/basket'
import * as takeawayWaitingBasketActions from '../../actions/components/takeawayWaitingBasket'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'

const mapStateToProps = (state) => {
  return {
    user: state.user,
    locale: state.locale,
    merchant: state.merchant,
    takeawayOrders: state.basket.takeawayOrders,
    basket: state.basket,
    isTakeawayAvailable: state.isTakeawayAvailable,
    query: state.query,
    campaign: state.campaign,
  }
}

const mapDispatchToProps = (dispatch) => {
  const { getBasket, setTakeawayStatus, createBasket, setTakeawayAvailable, setOutTradeNo,removePromoCode } = bindActionCreators(basketActions, dispatch)
  const { setTakeawayWaitingBasket } = bindActionCreators(takeawayWaitingBasketActions, dispatch)
  return {
    getBasket,
    createBasket,
    setTakeawayStatus,
    setTakeawayAvailable,
    setOutTradeNo,
    removePromoCode,
    setTakeawayWaitingBasket,
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(TakeawayWaitingSummary)))



// WEBPACK FOOTER //
// ./src/containers/components/TakeawayWaitingSummary.js